import {IconButton} from '@primer/react'
import {SquareCircleIcon} from '@primer/octicons-react'
import {useCreateCommand} from '../../hooks/useCreateCommand'
import {COMMAND_TYPES} from '@github-ui/copilot-shared-ui/ahp/command-types'
import {SessionState} from '../../types/session'
import type {Session} from '../../types/session'
import {sendEvent} from '@github-ui/hydro-analytics'

const STOPPABLE_STATES: string[] = [SessionState.InProgress, SessionState.WaitingForUser]

interface CLIStopButtonProps {
  session: Session
}

/**
 * Stop button for CLI sessions. Sends an abort command to the
 * mission control session so the CLI agent stops its current work.
 */
export function CLIStopButton({session}: CLIStopButtonProps) {
  const {createCommand, isPending} = useCreateCommand()

  if (!STOPPABLE_STATES.includes(session.state)) {
    return null
  }

  return (
    <IconButton
      icon={SquareCircleIcon}
      variant="invisible"
      className="fgColor-danger"
      size="medium"
      aria-label="Stop session"
      disabled={isPending}
      onClick={() => {
        if (!isPending) {
          createCommand({
            sessionId: session.id,
            content: '',
            type: COMMAND_TYPES.ABORT,
          })
          sendEvent('agent_sessions.task_view', {
            target: 'STOP_SESSION_BUTTON',
            session_id: session.id,
            task_id: session.resource_global_id,
          })
        }
      }}
      loading={isPending}
    />
  )
}
